import toast from 'react-hot-toast';
import { DeekSeekIntegration, relevantRootCauseResponse } from "../Components/Utilities/DeepSeekIntegration";

export const getHeaders = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem('NCProAccessToken')}`,
  },
});

export const FirstLetterCaps = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1)
};

export const rootColorFilter = (rootName = '') => {
  if (rootName === 'MANPOWER') return '#FCB433'
  else if (rootName === 'METHOD') return '#F14B62'
  else if (rootName === 'MACHINE') return '#BC3743'
  else if (rootName === 'MEASUREMENT') return '#66C068'
  else if (rootName === 'ENVIRONMENT') return '#3DC1F2'
  else return '#A66DF5'
}

export const sortFishboneKeys = (inputData) => {
  const orderedKeys = ["manpower", "method", "machine", "material", "environment", "measurement"];

  const sorted = {};
  for (const key of orderedKeys) {
    if (inputData[key]) {
      sorted[key] = inputData[key];
    }
  }
  return sorted;
}


export const validateAndRetrieveNCROtherFields = (data) => {
  return data.map((item) => {
    return {
      ...item,
      department: item.department === "Other" ? item.department_other : item.department,
      process_root_cause_identification: item.process_root_cause_identification === "Other"
        ? item.process_root_cause_identification_other
        : item.process_root_cause_identification,
      escape_point: item.escape_point === "Other" ? item.escape_point_other : item.escape_point,
      ndrc_identification: item.ndrc_identification === "Other" ? item.ndrc_identification_other : item.ndrc_identification,
      system_root_cause_identification: item.system_root_cause_identification === "Other"
        ? item.system_root_cause_identification_other
        : item.system_root_cause_identification,
    };
  });
};

export const validateAIRequiredFields = (fieldName, content) => {
  const fieldMapping = {
    "what_went_wrong": ["what_went_wrong"],
    "how_was_issue_identified": ["how_was_issue_identified"],
    "corrective_actions_ndrc": ["what_went_wrong", "escape_point", "ndrc_identification"],
    "process_root_cause_description": ["process_root_cause_description"],
    "preventive_action_plan": ["corrective_actions_ndrc", "process_root_cause_identification", "system_root_cause_identification"],
    "corrective_actions_system_root_cause": ["what_went_wrong", "system_root_cause_identification"],
    "corrective_actions_process_root_cause": ["what_went_wrong", "process_root_cause_description", "process_root_cause_identification"],
    "relevant_root_cause": ["what_went_wrong", "process_root_cause_description"],
  };

  const requiredFields = fieldMapping[fieldName] || [];
  const missingFields = [];

  const data = requiredFields.reduce((accumulator, key) => {
    const value = content.formData[key];
    const otherValue = content.formData[`${key}_other`];

    if (value === "Other" && !otherValue) {
      missingFields.push(key);
    } else if (!value) {
      missingFields.push(key);
    }

    accumulator[key] = value === "Other" ? otherValue : value || "";
    return accumulator;
  }, {});

  if (missingFields.length > 0) {
    const missingLabels = missingFields.map((field) => convertDBNameToUILabel(field)).join(", ");
    toast.error(`Please fill in the missing fields: ${missingLabels}`);
    return { isValid: false, data };
  }

  return { isValid: true, data };
};

export const handleAIClick = async (fieldName, content, setAiResponses) => {
  const { isValid, data } = validateAIRequiredFields(fieldName, content);
  if (!isValid) return;

  let dotIndex = 0;
  const loadingDots = [" .", " ..", " ...", "$@!"];
  const interval = setInterval(() => {
    setAiResponses(loadingDots[dotIndex]);
    dotIndex = (dotIndex + 1) % loadingDots.length;
  }, 500);

  try {
    const generatedResponse = fieldName === "relevant_root_cause" ? await relevantRootCauseResponse(data) : await DeekSeekIntegration(fieldName, data);
    clearInterval(interval);

    if (!generatedResponse || typeof generatedResponse !== "string") {
      setAiResponses("");
      return;
    }

    let index = 0;
    setAiResponses(".");

    const typingEffect = setInterval(() => {
      setAiResponses(generatedResponse.substring(0, index + 1));

      index++;
      if (index >= generatedResponse.length) {
        clearInterval(typingEffect);
      }
    }, 12);

  } catch (error) {
    clearInterval(interval);
    setAiResponses("Error fetching AI response");
  }
};

export const convertDBNameToUILabel = (fieldName) => {
  const fieldLabels = {
    "ncr_id": "NC ID",
    "date_of_issue": "NC Date",
    "department": "Department/Function",
    "reported_by": "Reported By",
    "ncr_type": "NC Type",
    "category": "Non-Conformance Category",
    "status": "Status of NC",
    "responsible_team_or_person": "Responsible Person/Team",
    "affected_item_component_no": "Part/Component Number",
    "affected_item_description": "Description",
    "affected_item_revision": "Revision",
    "affected_item_qty": "Qty",
    "affected_item_supplier_cust_name": "Customer / Supplier",
    "affected_item_remarks": "Remarks",
    "what_went_wrong": "What Went Wrong?",
    "how_was_issue_identified": "How Was the Issue Identified?",
    "severity_or_priority_level": "NC Priority Level / Severity",
    "location": "Location of Non-Conformance",
    "evidence_attachments": "Evidence/Attachment",
    "corrective_action_required": "Corrective Action Required",
    "approving_authority": "Approving Authority",
    "username": "Created By",
    "escape_point": "Escape Point",
    "ndrc_identification": "Non-Detected Root Cause (NDRC) Identification",
    "corrective_actions_ndrc": "Corrective Actions for Non-Detected Root Cause",
    "process_root_cause_description": "Process Root Cause Description",
    "process_root_cause_identification": "Process Root Cause Identification",
    "corrective_actions_process_root_cause": "Corrective Actions for Process Root Cause (PRC)",
    "system_root_cause_identification": "System Root Cause (SRC) Identification",
    "corrective_actions_system_root_cause": "Corrective Actions for System Root Cause (SRC)",
    "preventive_action_plan": "Preventive Action Plan",
    "preventive_action_implementation_timeline": "Implementation Timeline",
    "action_attachments": "Attachments - Action Proof",
    "corrective_action_review_completed": "Has the Corrective Action been completed?",
    "is_corrective_action_review_effective_resolving_issue": "Is the Corrective Action effective in resolving the issue?",
    "corrective_action_review_feedback": "Corrective Action Review Detailed Feedback",
    "corrective_action_review_verification_evidence": "Corrective Action Review Verification Evidence",
    "preventive_action_review_implemented": "Has the Preventive Action been implemented?",
    "preventive_action_review_sufficient_prevent_recurrence": "Is the Preventive Action sufficient to prevent recurrence?",
    "preventive_action_review_feedback": "Preventive Action Review Detailed Feedback",
    "preventive_action_review_verification_evidence": "Preventive Action Review Verification Evidence",
    "is_ncr_ready_for_closure": "Is the NC ready for closure?",
    "comments_for_closure": "Comments for Closure"
  };

  return fieldLabels[fieldName] || fieldName;
};

export const getProgressStepperStatus = (status, corrective_action_required) => {
  switch (status) {
    case 'In Action':
      return ['completed', 'inProgress', 'notStarted', 'notStarted'];

    case 'In Review':
      return ['completed', 'completed', 'inProgress', 'notStarted'];

    case 'In Closure':
      return corrective_action_required === 'No'
        ? ['completed', 'completed', 'skipped', 'inProgress']
        : ['completed', 'completed', 'completed', 'inProgress'];
    case 'Closed':
      return ['completed', 'completed', 'completed', 'completed'];

    default:
      return ['completed', 'inProgress', 'notStarted', 'notStarted'];
  }
};